import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LoadingButton } from '@mui/lab';
import { Button, DialogTitle, ListItemIcon, Paper, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { CommonHelper } from 'src/utils/commonHelper';

const LinkedInProfileAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");

  const handleConnectLinkedInProfile = () => {
    setLoadingOn(true);
    props.handleConnectLinkedInProfile();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? `${translate('integration.linkedin.reconnect_linkedin')}`
            : `${translate('integration.linkedin.connect_linkedin')}`}
        </Typography>
        {(!isCustomDomain || isPortalAdmin)&& (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=e5hkxC96HuQ', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold' }}>
          {props.reAuth
            ? `${translate('common.verify_these_requirements')}:`
            : `${translate('common.make_sure_completed_steps')}:`}
        </Typography>

        <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, mt: 2 }}>
          <ListItemIcon>
            <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
          </ListItemIcon>
          <Typography variant="body1">
            {props.reAuth
              ? `${translate('integration.linkedin.linkedin_still_valid')}`
              : `${translate('integration.linkedin.standard_linkedin_profile')}`}
          </Typography>
        </Paper>

        <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
          <ListItemIcon>
            <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
          </ListItemIcon>
          <Typography variant="body1">
            {props.reAuth
              ? `${translate('integration.linkedin.profile_remains_active')}`
              : `${translate('integration.linkedin.linkedin_profile_active')}`}
          </Typography>
        </Paper>

        <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
          <ListItemIcon>
            <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
          </ListItemIcon>
          <Typography variant="body1">
            {props.reAuth
              ? `${translate('integration.linkedin.authorized_linkedin_account')}`
              : `${translate('integration.linkedin.logged_into_linkedin_account')}`}
          </Typography>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectLinkedInProfile();
          }}
        >
          {props.reAuth ? `${translate('common.reconnect')}` : `${translate('common.connect')}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default LinkedInProfileAuthorizationModal;
